import React, { useState } from 'react';
import CommonCard from '../../../Components/General/CommonCard';
import classes from './ProfileCard.module.css';
import Button from '../../../Components/UI/Button';
import { EditIconPencil } from '../../../Assets/icons';
import LabeledText from '../../../Components/General/LabeledText';
import { Col, Row } from 'react-bootstrap';
import ChangedEmailModal from '../../../Modals/ChangedEmailModal';
import OtpVerificationModal from '../../../Modals/EmailVerificationCode';
import ChangedNumberModal from '../../../Modals/ChangedNumberModal';
import ChangedSecondaryNumberModal from '../../../Modals/ChangedSecondaryPhoneNumber';
import PinCodeModal from '../../../Modals/PinCodeModal';
import AssignPaModal from '../../../Modals/AssignPAModal';
import { formatPhoneNumber } from '../../../Helpers';
import ProfileImageUploader from '../../../Components/UI/ProfileImageUploader';
const ProfileCard = ({
  generateOtpForUpdateEmail,
  updateEmail,
  updateSecondaryNumber,
  loading,
  profile,
  onUpdateProfileImage
}) => {
  const [showChangeEmailModal, setShowChangeEmailModal] = useState(false);
  const [showOtpVerificationModal, setShowOtpVerificationModal] = useState(false);
  const [showChangedNumberModal, setShowChangedNumberModal] = useState(false);
  const [showChangedSecondaryNumberModal, setShowChangedSecondaryNumberModal] = useState(false);
  const [showPinCodeModal, setShowPinCodeModal] = useState(false);
  const [showAssignPaModal, setShowAssignPaModal] = useState(false);
  return (
    <>
      <CommonCard className={classes.wrapper}>
        <ul className={classes.cardWrapper}>
          <li className={classes.profileCardWrapper}>
            <ProfileImageUploader
              onUpload={(image) => {
                onUpdateProfileImage({ userImage: image });
              }}
              profileImage={profile?.profileImage}
              fallback={profile?.fullName?.slice(0, 1)}
            />
            {/* <span className={classes.namePlaceholderWrapper}>A</span> */}
          </li>
          <li>
            <div className={classes.content}>
              <div className={classes.personalContainer}>
                <h2>{profile?.fullName}</h2>
                <div className={classes.emailWrapper}>
                  <p>{profile?.email}</p>
                  <Button
                    onClick={() => {
                      setShowChangeEmailModal(true);
                    }}
                    className={classes.editBtn}
                    leftIcon={<EditIconPencil size={12} color="var(--primary-color)" />}
                    variants="iconBtn"
                  />
                </div>
              </div>
            </div>
            <div className={classes.details}>
              <ul lg={12} xl={6} className={classes['pt-14px']}>
                <div className={classes.editWrapper}>
                  <LabeledText
                    label={'Phone Number: '}
                    value={
                      profile?.phoneNumber ? (
                        formatPhoneNumber(profile?.phoneNumber)
                      ) : (
                        <span
                          className={classes.linkBtn}
                          onClick={() => {
                            setShowChangedNumberModal(true);
                          }}>
                          Add Now
                        </span>
                      )
                    }
                  />
                  <Button
                    onClick={() => {
                      setShowChangedNumberModal(true);
                    }}
                    className={classes.editBtn}
                    leftIcon={<EditIconPencil size={12} color="var(--primary-color)" />}
                    variants="iconBtn"
                  />
                </div>
              </ul>
              <ul lg={12} xl={6} className={classes['pt-14px']}>
                <div className={classes.editWrapper}>
                  <LabeledText
                    label={'Secondary Phone: '}
                    value={
                      profile?.secondPhoneNumber ? (
                        formatPhoneNumber('+' + profile?.secondPhoneNumber?.slice())
                      ) : (
                        <span
                          className={classes.linkBtn}
                          onClick={() => {
                            setShowChangedSecondaryNumberModal(true);
                          }}>
                          Add Now
                        </span>
                      )
                    }
                  />
                  <Button
                    onClick={() => {
                      setShowChangedSecondaryNumberModal(true);
                    }}
                    className={classes.editBtn}
                    leftIcon={<EditIconPencil size={12} color="var(--primary-color)" />}
                    variants="iconBtn"
                  />
                </div>
              </ul>
              <ul lg={12} xl={6} className={classes['pt-14px']}>
                <LabeledText
                  label={'Assigned Assistant: '}
                  className={classes.makeLink}
                  value={'Add Now'}
                />
              </ul>
              <ul lg={12} xl={6} className={classes['pt-14px']}>
                <LabeledText label={'Assistant Phone: -'} value={''} />
              </ul>
            </div>
          </li>
        </ul>
      </CommonCard>

      {showChangeEmailModal && (
        <ChangedEmailModal
          loading={loading}
          setShowOtpVerificationModal={setShowOtpVerificationModal}
          show={showChangeEmailModal}
          setShow={setShowChangeEmailModal}
          onSubmit={generateOtpForUpdateEmail}
        />
      )}
      {showOtpVerificationModal && (
        <OtpVerificationModal
          loading={loading}
          onSubmit={updateEmail}
          show={showOtpVerificationModal}
          setShow={setShowOtpVerificationModal}
        />
      )}
      {showChangedNumberModal && (
        <ChangedNumberModal
          loading={loading}
          show={showChangedNumberModal}
          setShow={setShowChangedNumberModal}
        />
      )}
      {showChangedSecondaryNumberModal && (
        <ChangedSecondaryNumberModal
          loading={loading}
          show={showChangedSecondaryNumberModal}
          setShow={setShowChangedSecondaryNumberModal}
          onSubmit={updateSecondaryNumber}
        />
      )}
      {showPinCodeModal && <PinCodeModal show={showPinCodeModal} setShow={setShowPinCodeModal} />}
      {showAssignPaModal && (
        <AssignPaModal show={showAssignPaModal} setShow={setShowAssignPaModal} />
      )}
    </>
  );
};

export default ProfileCard;
